"use client";

import { MultiStepForm } from './components/MultiStepForm';
import { CountryWideFormConfig } from './CountryWideFormConfig';

export function CountryWideForm() {
  return (
    <MultiStepForm 
      config={CountryWideFormConfig}
      className="country-wide-form"
    />
  );
} 